// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3Yih3","consentsList":"PatientConsents_consentsList__1wdNd","consentsListEmpty":"PatientConsents_consentsListEmpty__20VT6"};